"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LabeledRatingStars = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _LabeledRatingStars = require("./LabeledRatingStars.styles");
var _excluded = ["ratingStars", "label"];
/**
 * Displays a `RatingStars` component with
 * an accompanying text label.
 *
 * @related ['TextButton']
 * @since 8.4.0
 */
var LabeledRatingStars = /*#__PURE__*/(0, _react.forwardRef)(function (_ref, forwardedRef) {
  var ratingStars = _ref.ratingStars,
    label = _ref.label,
    rest = (0, _objectWithoutProperties2.default)(_ref, _excluded);
  return /*#__PURE__*/_react.default.createElement(_LabeledRatingStars.StyledLabeledRatingStars, (0, _extends2.default)({}, rest, {
    ref: forwardedRef
  }), ratingStars, label);
});
exports.LabeledRatingStars = LabeledRatingStars;
LabeledRatingStars.displayName = 'LabeledRatingStars';
LabeledRatingStars.propTypes = {
  /** The `RatingStars` component. */
  ratingStars: _propTypes.default.node.isRequired,
  /**
   * The label to display next to the Rating Stars. Usually, this will be a `TextButton`.
   */
  label: _propTypes.default.node
};
LabeledRatingStars.defaultProps = {
  label: undefined
};